let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4yz16")).then(() => parcelRequire('1MZYA'));